module.exports = __webpack_public_path__ + "img/filters_is.f3a8cd1a.png";